import { AirWeightBracketPrice } from "./air-weight-bracket-price.model";
import { AirWeightBracketPriceDict } from "./air-weight-bracket-price-dict.type";
import { AirWeightBracketName } from "./air-weight-bracket-name.type.const";
import { AirWeightBracketPriceDictMapper } from "./air-weight-bracket-price-dict.mapper";

export class AirWeightBracketPrices {
  private weightBracketPriceDict = <AirWeightBracketPriceDict>{};

  constructor(data: AirWeightBracketPrice[]) {
    this.setWeightBracketPriceDict(data);
  }

  public getPrices(): AirWeightBracketPriceDict {
    return this.weightBracketPriceDict;
  }

  public setPrices(param: AirWeightBracketPriceDict) {
    this.weightBracketPriceDict = param;
  }

  public getPrice(param: AirWeightBracketName): number {
    return this.getPrices()[param] ? this.getPrices()[param].getValue() : null;
  }

  public setPrice(param: AirWeightBracketName, val: number) {
    try {
      this.getPrices()[param] = new AirWeightBracketPrice(param, val);
    } catch (e) {
      console.error(`can't set ${param} container with ${val} (${e})`);
    }
  }

  public getWeightBracketPriceNames(): AirWeightBracketName[] {
    return <AirWeightBracketName[]>Object.keys(this.weightBracketPriceDict);
  }

  public getRequestParams() {
    return AirWeightBracketPriceDictMapper.toArray(this.weightBracketPriceDict);
  }

  public hasAtLeastOnePrice(equipment: string[] = []) {
    return equipment
      .map((weightBracketName) =>
        this.weightBracketPriceDict[weightBracketName]
          ? this.weightBracketPriceDict[weightBracketName]
          : null,
      )
      .some((val) => val !== null);
  }

  private setWeightBracketPriceDict(
    data: AirWeightBracketPrices | AirWeightBracketPrice[],
  ) {
    if (data instanceof AirWeightBracketPrices) {
      this.weightBracketPriceDict = { ...data.getPrices() };
    }

    if (Array.isArray(data)) {
      this.weightBracketPriceDict =
        AirWeightBracketPriceDictMapper.toDict(data);
    }
  }
}
